import DriveEndType from "../../../enums/drive-end-type";
import FootballState from "../../../state/football-state";
import OncePerPlayRule from "../../../../common/once-per-play-rule";

//In this case we only need to check the play for any penalties, that would prevent normal changing of downs
export default class Touchdown extends OncePerPlayRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const allowedFragments = [
            FootballState.Rush,
            FootballState.PassComplete,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.PassIntercepted,
            FootballState.FieldGoalFakeRun,
            FootballState.NoRecoveryKickReturn,
            FootballState.FumbleNotRecovered,
            FootballState.FumbleRecovered,
            FootballState.EndOfPlay
        ];
        return (
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            }) &&
            !ruleContext.isSafety &&
            !play.historyContains(FootballState.PenaltyAccepted) &&
            !play.historyContains(FootballState.PlayPenalty) &&
            !play.historyContains(FootballState.TouchBack) &&
            allowedFragments.includes(fragment?.associatedState) &&
            ((gameContext.isVisitorPossession() &&
                gameContext.fieldPosition <= 0) ||
                (gameContext.isHomePossession() &&
                    gameContext.fieldPosition >= gameContext.getFieldLength()))
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { gameConfig } = gameContext;
        gameContext.increaseTeamPossessionScore(gameConfig.scoring.touchdown);
        ruleContext.playPoints = gameConfig.scoring.touchdown;
        ruleContext.isTouchdown = true;
        this.flagChanges(gameContext);
        await this.kickoffContextChanges(gameContext);
    }

    flagChanges() {}

    /*
	What is happening here:
	1.) We trigger Drive Start if a drive does not exist when Touchdown occurs (eg. Kickoff -> Returned -> Touchdown).
	2.) We trigger PAT if drive exists for play.
	*/
    async kickoffContextChanges(gameContext) {
        const { currentDriveId } = gameContext;
        const shouldTriggerDrive = !currentDriveId;
        const shouldPAT = !!currentDriveId;

        gameContext.triggerPAT = shouldPAT;
        gameContext.setDriveContext({
            triggerDrive: shouldTriggerDrive,
            previousDriveEndType: DriveEndType.Touchdown
        });
    }
}
